module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/mainBg_826abf96c20ba7d3875c450515549270.jpg";